import type { IconGalleryProps } from '~/legacy/types';

import Icon from './Icon';

const IconGallery = ({
  icons,
  hrefs,
  fillColour,
  componentWrapperClass,
  target = '_blank'
}: IconGalleryProps) => {
  return (
    <ul className={componentWrapperClass}>
      {icons.map((icon, index: number) => (
        <li key={index} className={`${componentWrapperClass}__item`}>
          <a
            className={`${componentWrapperClass}__link ${componentWrapperClass}__link--${icon}`}
            href={hrefs[index]}
            target={target}
            rel="noopener noreferrer"
            title={`Sole Supplier on ${
              icon.charAt(0).toUpperCase() + icon.slice(1)
            } [New Window]`}
          >
            <Icon
              name={icon}
              width="25"
              height="25"
              fill={fillColour}
              viewBox="0 0 1792 1792"
            />
          </a>
        </li>
      ))}
    </ul>
  );
};

export default IconGallery;
